import {createActions} from 'client/framework';

const normalActions = ['TOGGLE_VISIBILITY', 'SET_VISIBILITY'];

export default createActions(null, normalActions);
